(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('userService', userService);


    /**
        * @ngdoc service
        * @name swif.framework.userService
        * @description manage the authenticatedUser and provide an API to get data
        * @requires swif.framework.settingsService
        * @requires swif.framework.dataService
    **/
    function userService($rootScope, $q, $route, $location, settings, dataService, CacheService, Idle) {
        'ngInject';
        var service = {};
        service.getAuthenticatedUser = getAuthenticatedUser;
        service.getAuthenticatedUserData = getAuthenticatedUserData;
        service.getAccessRights = getAccessRights;
        service.getPartnerAddress = getPartnerAddress;
        service.getPartner = getPartner;
        service.isAuthenticated = isAuthenticated;
        service.setAccessRights = setAccessRights;
        service._setAuthenticatedUserData = _setAuthenticatedUserData;
        service.setAuthenticatedUser = setAuthenticatedUser;
        service.getTimeZone = getTimeZone;
        service.getMomentFromServer = getMomentFromServer;
        service.getManageableTeamsFilter = getManageableTeamsFilter;
        service.getManageableOfficersFilter = getManageableOfficersFilter;
        service.getManageableTeamsAndOfficers = getManageableTeamsAndOfficers;
        service.getSessionInfo = getSessionInfo;
        service.redirectAfterLogin = redirectAfterLogin;
        service.redirectIfWrongDB = redirectIfWrongDB;
        service.logout = logout;
        service.hasGroup = hasGroup;
        service.getLandingPage = getLandingPage;

        return service;

        function getAuthenticatedUser() {
            return settings.get('authenticated_user');
        }
        function getAuthenticatedUserData() {
            return settings.get('authenticated_user_data');
        }
        function getAccessRights() {
            var ac = settings.get('access_rights');
            if (!ac) {
                service.setAccessRights();
                ac = settings.get('access_rights');
            }
            return ac;
        }
        function getPartnerAddress(fields) {
            var filter = {};
            dataService.addFilter(filter, 'user_id.id', 'in',
                [service.getAuthenticatedUserData().id]
            );
            filter.fields = fields;
            return dataService.get('partner_address', undefined, filter)
            .then(function (pas) {
                if (!_.isEmpty(pas)) {
                    return pas[0];
                }
            });
        }
        function getPartner(fields) {
            var filter = {};
            dataService.addFilter(filter, 'address.id', 'in',
                [service.getAuthenticatedUserData().address_id[0]]
            );
            filter.fields = fields;
            return dataService.get('partner', undefined, filter)
            .then(function (partner) {
                if (!_.isEmpty(partner)) {
                    return partner[0];
                }
            });
        }
        function isAuthenticated() {
            if (settings.get('authenticated_user')) {
                return true;
            }
            return false;
        }
        function setAccessRights() {
            var userData = service.getAuthenticatedUserData();
            var access_rights = {};
            if (userData) {
                _.forEach(userData.access_rights, function (permission) {
                    access_rights[permission] = true;
                });
            }
            settings.set('access_rights', access_rights);
        }
        function _setAuthenticatedUserData() {
            var deferred = $q.defer();
            var user = settings.get('authenticated_user');
            if (user) {
                if (user.id) {
                    deferred.resolve(user);
                } else {
                    var id = settings.get('authenticated_user').uid;
                    dataService.get('user', id).then(function (userData) {
                        if (userData.access_rights) {
                            userData.access_rights = JSON.parse(userData.access_rights);
                        }
                        settings.set('authenticated_user_data', userData);
                        service.setAccessRights();
                        deferred.resolve(user);
                    }, function (error) {
                        deferred.reject(error);
                    });
                }
            }
            return deferred.promise;
        }
        function setAuthenticatedUser(data) {
            var deferred = $q.defer();
            if (data !== undefined) {
                settings.set('authenticated_user', data.result);
                settings.set('token', data.result.session_id);
                service._setAuthenticatedUserData()
                .then(function () {
                    deferred.resolve({
                        user: data.result,
                        token: data.result.session_id
                    });
                }, function (error) {
                    deferred.reject(error);
                });
            } else {
                settings.reset();
                deferred.resolve();
            }
            return deferred.promise;
        }
        function getTimeZone() {
            var u = service.getAuthenticatedUser(); //context_tz;
            if (u) {
                if (u.context) {
                    return u.context.tz;
                }
            }
        }
        function getMomentFromServer(d) {
            return moment.utc(d);
        }
        function getManageableTeamsFilter(extra, options) {
            var addFilter = dataService.addFilter;
            if (extra) {
                addFilter = function (params, field, operator, value) {
                    dataService.addExtraFilter(params, 'extra', field, operator, value);
                };
            }
            var user = service.getAuthenticatedUserData();
            var user_rights = user.access_rights;
            var filter = {};
            filter.fields = ['id', 'name', 'manager_id', 'user_ids', 'user_names', 'color'];
            if (_.contains(user_rights, 'openstc_tasks_plan_service')) {
                addFilter(
                    filter,
                    'service_ids.id', 'child_of', user.service_ids
                );
            } else if (_.contains(user_rights, 'openstc_tasks_plan_team')) {
                addFilter(
                    filter,
                    'manager_id.id', '=', user.id
                );
            }
            if (options) {
                if (options.is_parcauto) {
                    addFilter(filter, 'service_ids.is_parcauto', '=', true);
                }
            }
            return filter;
        }
        function getManageableOfficersFilter(extra, options) {
            var addFilter = dataService.addFilter;
            if (extra) {
                addFilter = function (params, field, operator, value) {
                    dataService.addExtraFilter(params, 'extra', field, operator, value);
                };
            }
            var user = service.getAuthenticatedUserData();
            var user_rights = user.access_rights;
            var filter = {};
            filter.fields = ['id', 'name', 'complete_name', 'team_ids', 'hex_color'];
            if (_.contains(user_rights, 'openstc_tasks_plan_service')) {
                addFilter(
                    filter,
                    'service_ids.id', 'child_of', user.service_ids
                );
            } else if (_.contains(user_rights, 'openstc_tasks_plan_base')) {
                addFilter(
                    filter,
                    'id', '=', user.id
                );
            }
            addFilter(
                filter, 'is_assignable_to_task', '=', true
            );
            if (!_.isEmpty(filter)) {
                addFilter(
                    filter, 'id', '!=', 1
                );
            }
            if (options) {
                if (options.is_parcauto) {
                    addFilter(filter, 'service_ids.is_parcauto', '=', true);
                }
            }
            return filter;
        }
        function getManageableTeamsAndOfficers() {
            var user = service.getAuthenticatedUser();
            var userId = user.uid;
            return dataService.call(
                'user',
                'get_manageable_teams_and_officers',
                [userId]
            );
        }
        function getSessionInfo() {
            var deferred = $q.defer();
            var user = service.getAuthenticatedUser();
            if (user) {
                dataService.post(undefined, {
                    url: '/web/session/get_session_info',
                    params: {
                        session_id: user.session_id
                    }
                }, false).then(function (session) {
                    deferred.resolve(session);
                }, function (error) {
                    deferred.reject(error);
                });
            } else {
                deferred.reject();
            }
            return deferred.promise;
        }
        function redirectAfterLogin() {
            var nextPath = $location.search().next;
            $location.search('next', null);
            let landingPage = service.getLandingPage();
            if (nextPath && nextPath !== '/logout') {
                if (_.contains(_.keys($route.routes), nextPath)) {
                    $location.path(nextPath);
                } else {
                    $location.path(landingPage);
                }
            } else {
                $location.path(landingPage);
            }
        }
        function redirectIfWrongDB() {
            var user = service.getAuthenticatedUser();
            if (user && settings.app.db) {
                if (settings.app.db !==  user.db) {
                    $location.search('next', $location.path());
                    $location.path('/logout');
                }
            }
        }
        function logout() {
            service.setAuthenticatedUser();
            CacheService.removeAll();
            settings.reset();
            $rootScope.$emit('authenticationEvent');
            $location.path('/login');

            if(settings.app.features.timeoutDuration){
                Idle.unwatch()
            }
        }
        function hasGroup(id) {
            var data;
            if (_.isNumber(id)) {
                data = service.getAuthenticatedUser();
                if (data) {
                    return data.indexOf(id) !== -1;
                }
            }
        }

        function getLandingPage(){
            var user = service.getAuthenticatedUserData();
            let isCitizen = false;
            let isSupplier = false;
            let isPartner = false;
            if (user){
                let hasOpenstc = settings.app.modules.openstc;
                isCitizen = hasOpenstc && !_.contains(user.access_rights, 'openstc_full_view');
                isSupplier = user.is_supplier;
                isPartner = _.contains(user.access_rights, 'PRES');
            }
            let landingPage = settings.app.defaultPage;
            if (isCitizen) {
                if (settings.app.defaultCitizenPage) {
                    landingPage = settings.app.defaultCitizenPage;
                } else {
                    console.warn('You should have a defaultCitizenPage value to have a proper landing page');
                }
            }
            if (isSupplier) {
                if (settings.app.defaultProvidersPage) {
                    landingPage = settings.app.defaultProvidersPage;
                } else {
                    console.warn('You should have a defaultProvidersPage value to have a proper landing page');
                }
            }
            if (isPartner) {
                landingPage = '/interventions/tasks/table_view'
            }
            return landingPage;
        }

    }

})();
